import React, { Component } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import ImageSlideComponent from "../imageSlideComponent/imageSlide.component";
import "./tray.component.scss";
import image from "../../assets/close.svg";
import { ITrayComponentProps } from "../types/props";
import { CartState } from "../enums";

const TrayComponentContainer = ({
  closeTray,
  moveSlide,
  removeSlide,
  cartState,
  open,
  slides,
}) => {


  const generateImageList = () => {
    if (cartState !== CartState.LISTING) return null;
    return (
      <div className="presentation-tray--list">
        <ul>{imageList()}</ul>
      </div>
    );
  };

  const handleBeginSlideshow = () => {
    closeTray();
    window.dispatchEvent(new Event("beginSlideshow"));
  }
  const generateFooter = () => {
    return (
      <div className="presentation-tray--footer">
        <div className="presentation-tray--footer-buttons">
          <button
            className="ampri-button-primary"
            disabled={cartState === CartState.LOADING || slides?.length === 0}
            data-automation="global-continue"
            onClick={handleBeginSlideshow}
          >
            Create presentation
          </button>
          <button
            className="ampri-button-tertiary"
            disabled={cartState === CartState.LOADING}
            onClick={closeTray}
          >
            Add more content modules
          </button>
        </div>
      </div>
    );
  };

  const generateEmptyState = () => {
    if (cartState !== CartState.EMPTY) return null;
    return (
      <div className="presentation-tray--empty">
        <p>Your presentation is empty</p>
        <p>Add some content modules to get started.</p>
      </div>
    );
  };

  const generateErrorState = () => {
    if (cartState !== CartState.ERROR) return null;
    return (
      <div className="presentation-tray--error">
        <h3>Error</h3>
        <p>
          An error has occured, please try again or contact the site
          administrator.
        </p>
      </div>
    );
  };

  const imageList = (): JSX.Element[] => {
    if (slides.length) {
      return slides?.map((slide: any, index:any) => {
        return (
          <div className="image-view-link" key={slide.id}>
            <ImageSlideComponent
              key={index}
              title={slide.title}
              image={slide.image}
              index={index}
              last={index === slides?.length - 1}
              moveSlide={moveSlide}
              removeSlide={removeSlide}
            />
          </div>
        );
      });
    }
  };

  return (
    <div>
      <div
        className={classNames({
          "presentation-tray": true,
          "presentation-tray--open": open,
          "presentation-tray--loading": cartState === CartState.LOADING,
          "presentation-tray--creating": cartState === CartState.CREATING,
        })}
      >
        <div className="presentation-tray--header">
          <span>
            <i>
              <span>{slides?.length}</span>
            </i>
            Your presentation
          </span>
          <span className="presentation-tray--close">
            <button
              onClick={closeTray}
              data-automation="global-challenges-presentation-tray-button-close"
            >
              {" "}
              <img src={`/dist/${image}`} />
            </button>
          </span>
        </div>
        {generateEmptyState()}
        {slides.length ? generateImageList(): null}
        {generateFooter()}
        {generateErrorState()}
      </div>
      <div
        onClick={closeTray}
        className={classNames({
          "presentation-tray--screen-overlay": true,
          "presentation-tray--screen-overlay-active": open,
        })}
      ></div>
    </div>
  );
};

class TrayComponent extends Component<ITrayComponentProps> {
  render() {
    return ReactDOM.createPortal(
      <TrayComponentContainer
        closeTray={this.props.closeTray}
        moveSlide={this.props.moveSlide}
        removeSlide={this.props.removeSlide}
        cartState={this.props.cartState}
        open={this.props.open}
        slides={this.props.slides} 
      />,
      document.getElementById("presentation-tray")
    );
  }
}

export default TrayComponent;
